'use strict';

Object.defineProperty(exports, "__esModule", { value: true });
exports.ContentMixin = exports.ContentEvent = void 0;
var tslib_1 = require("tslib");
var vue_property_decorator_1 = require("vue-property-decorator");
var ContentEvent;
(function (ContentEvent) {
    ContentEvent["LOAD_INIT"] = "contentLoadInit";
    ContentEvent["LOAD_ERROR"] = "contentLoadError";
    ContentEvent["LOAD"] = "contentLoad";
})(ContentEvent = exports.ContentEvent || (exports.ContentEvent = {}));
/**
 * Mixin emitting events from content load lifecycle.
 *
 * There are 3 content load lifecycle methods available:
 *  - onContentLoadInit - should be called right before loading content
 *  - onContentLoadError - should be called on content loading error
 *  - onContentLoad - should be called after all the content was loaded
 */
var ContentMixin = /** @class */ (function (_super) {
    tslib_1.__extends(ContentMixin, _super);
    function ContentMixin() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.contentLoadTimer = null;
        _this.contentChunks = 0;
        return _this;
    }
    Object.defineProperty(ContentMixin.prototype, "contentIsLoading", {
        get: function () {
            return this.contentChunks >= 0;
        },
        enumerable: false,
        configurable: true
    });
    ContentMixin.prototype.mounted = function () {
        this.childLoadInitListener = this.onChildLoadInit.bind(this);
        this.childLoadListener = this.onChildLoad.bind(this);
        this.childLoadErrorListener = this.onChildLoadError.bind(this);
        this.$el.addEventListener(ContentEvent.LOAD_INIT, this.childLoadInitListener);
        this.$el.addEventListener(ContentEvent.LOAD, this.childLoadListener);
        this.$el.addEventListener(ContentEvent.LOAD_ERROR, this.childLoadErrorListener);
    };
    ContentMixin.prototype.destroyed = function () {
        if (this.childLoadInitListener) {
            this.$el.removeEventListener(ContentEvent.LOAD_INIT, this.childLoadInitListener);
        }
        if (this.childLoadListener) {
            this.$el.removeEventListener(ContentEvent.LOAD, this.childLoadListener);
        }
        if (this.childLoadErrorListener) {
            this.$el.removeEventListener(ContentEvent.LOAD_ERROR, this.childLoadErrorListener);
        }
    };
    /**
     * Use when content loading is initialized
     */
    ContentMixin.prototype.onContentLoadInit = function () {
        if (this.contentLoadTimer) {
            clearTimeout(this.contentLoadTimer);
            this.contentLoadTimer = null;
        }
        if (this.contentChunks === 0) {
            this.handleContentLoadInit();
        }
        this.contentChunks++;
    };
    /**
     * Use when content is loaded
     */
    ContentMixin.prototype.onContentLoad = function (content) {
        this.onContentChunkLoadEnd(content);
    };
    /**
     * Use when there was an error loading content
     */
    ContentMixin.prototype.onContentLoadError = function (error) {
        this.onContentChunkLoadEnd();
        this.handleContentLoadError(error);
    };
    /**
     * Emitted when loading component content has been initialized
     */
    ContentMixin.prototype.handleContentLoadInit = function () {
        return;
    };
    /**
     * Emitted when component content has been loaded.
     * This will also wait for al te children content to load
     * Provides loaded content
     */
    ContentMixin.prototype.handleContentLoad = function (content) {
        return content;
    };
    /**
     * Emitted when there was an error loading component data.
     * Provides error message
     */
    ContentMixin.prototype.handleContentLoadError = function (error) {
        if (error instanceof Error) {
            return error.message;
        }
        return error;
    };
    ContentMixin.prototype.onChildLoadInit = function (event) {
        event.stopPropagation();
        this.onContentLoadInit();
    };
    ContentMixin.prototype.onChildLoad = function (event) {
        event.stopPropagation();
        this.onContentLoad(event.detail[0]);
    };
    ContentMixin.prototype.onChildLoadError = function (event) {
        event.stopPropagation();
        this.onContentLoadError(event.detail[0]);
    };
    ContentMixin.prototype.onContentChunkLoadEnd = function (content) {
        var _this = this;
        this.contentChunks--;
        if (this.contentChunks === 0) {
            // use delay to avoid race condition between multiple content loads
            this.contentLoadTimer = setTimeout(function () {
                _this.handleContentLoad(content);
            }, 100);
        }
    };
    tslib_1.__decorate([
        vue_property_decorator_1.Emit('contentLoadInit')
    ], ContentMixin.prototype, "handleContentLoadInit", null);
    tslib_1.__decorate([
        vue_property_decorator_1.Emit('contentLoad')
    ], ContentMixin.prototype, "handleContentLoad", null);
    tslib_1.__decorate([
        vue_property_decorator_1.Emit('contentLoadError')
    ], ContentMixin.prototype, "handleContentLoadError", null);
    ContentMixin = tslib_1.__decorate([
        vue_property_decorator_1.Component
    ], ContentMixin);
    return ContentMixin;
}(vue_property_decorator_1.Vue));
exports.ContentMixin = ContentMixin;
